import {
	Carousel,
	CarouselContent,
	CarouselItem,
	CarouselNext,
	CarouselPrevious,
} from "@/components/ui/carousel";
import type { Data } from "@/types/data";
import NavItem from "./nav-item";

interface HeroProps {
	data: Data;
}

export default function Hero({ data }: HeroProps) {
	const activeBanners = data["area-inicial"].carrossel.banners.filter(
		(banner) => banner.ativo,
	);
	const banners = activeBanners.length
		? activeBanners
		: data["area-inicial"].carrossel.banners;

	if (!banners.length) {
		return null;
	}

	return (
		<section id="top" className="relative bg-zinc-950">
			<Carousel className="w-full" opts={{ loop: true }}>
				<CarouselContent className="-ml-0">
					{banners.map((banner, index) => {
						const isConsultationBanner = ["banner2.avif"].includes(
							banner.imagem,
						);

						return (
							<CarouselItem key={`${banner.imagem}-${index}`} className="pl-0">
								<article className="relative min-h-[520px] overflow-hidden md:min-h-[620px]">
									<div
										className="absolute inset-0 bg-cover bg-center"
										style={{
											backgroundImage: `url('/banners/${
												isConsultationBanner ? "banner2.avif" : banner.imagem
											}')`,
										}}
										aria-hidden="true"
									/>
									<div
										className={`absolute inset-0 ${
											isConsultationBanner
												? "bg-gradient-to-r from-zinc-950/85 via-zinc-950/55 to-zinc-950/15"
												: "bg-gradient-to-r from-zinc-950/95 via-zinc-950/65 to-zinc-950/25"
										}`}
										aria-hidden="true"
									/>

									<div
										className={`relative mx-auto flex min-h-[520px] max-w-7xl px-4 sm:px-6 lg:px-8 md:min-h-[620px] ${
											isConsultationBanner
												? "flex-col-reverse items-center justify-center gap-4 py-8 md:flex-row md:justify-between md:gap-10 md:py-16"
												: "items-center py-14 md:py-20"
										}`}
									>
										<div className={`max-w-2xl text-white ${isConsultationBanner ? "p-4 md:p-8" : "p-6 md:p-8"}`}>
										<p className="animate-fade-up text-sm font-semibold uppercase tracking-wide text-brand-secondary-200">
											{data["area-inicial"].mensagem}
										</p>
										<h1 className="animate-fade-up animate-fade-up-delay-1 mt-3 text-3xl font-semibold leading-tight text-balance sm:text-4xl md:text-5xl">
											{banner.titulo}
										</h1>
										<p className="animate-fade-up animate-fade-up-delay-2 mt-4 max-w-xl text-sm leading-relaxed text-zinc-200 sm:text-base">
											{banner.descricao}
										</p>

										<div className="mt-7 flex flex-col gap-3 sm:flex-row">
											<div className="inline-flex items-center justify-center rounded-md bg-brand-600 px-5 py-3 text-sm font-semibold text-white transition-all duration-200 hover:bg-brand-700 active:scale-[0.97]">
												<NavItem
													data={data}
													label={banner.label}
													href={banner.href}
													className="inline-flex items-center"
												/>
											</div>
											{banner.url && (
												<a
													href={banner.url}
													target="_blank"
													rel="noopener noreferrer"
													className="inline-flex items-center justify-center rounded-md border border-zinc-200/60 bg-white/10 px-5 py-3 text-sm font-semibold text-zinc-100 transition-colors hover:bg-white/20"
												>
													Saiba mais
												</a>
											)}
										</div>
									</div>
								{isConsultationBanner && (
									<img
										src="/banners/moacir-mobile.png"
										alt="Dr. Damine Ferreira Cabral"
										className="size-36 shrink-0 rounded-full border-4 border-brand-600 object-cover shadow-xl md:size-64"
									/>
								)}
								</div>
							</article>
						</CarouselItem>
				);
			})}
				</CarouselContent>
				<CarouselPrevious className="left-3 hidden border-white/40 bg-white/90 text-zinc-900 hover:bg-white md:inline-flex" />
				<CarouselNext className="right-3 hidden border-white/40 bg-white/90 text-zinc-900 hover:bg-white md:inline-flex" />
			</Carousel>
		</section>
	);
}
